import BalloonParameter from '@/models/game/parameters/balloon'
import BarrelParameter from '@/models/game/parameters/barrel'
import CraneParameter from '@/models/game/parameters/crane'
import EmptyParameter from '@/models/game/parameters/empty'
import GachaParameter from '@/models/game/parameters/gacha'
import GamelessParameter from '@/models/game/parameters/gameless'
import GameParameterInterface from '@/models/game/parameters/interface'
import JankenParameter from '@/models/game/parameters/janken'
import MovieGachaParameter from '@/models/game/parameters/movie-gacha'
import RouletteParameter from '@/models/game/parameters/roulette'
import ScratchParameter from '@/models/game/parameters/scratch'
import SelectCardParameter from '@/models/game/parameters/select-card'
import SlotParameter from '@/models/game/parameters/slot'
import TurningLotteryParameter from '@/models/game/parameters/turning-lottery'
import WaniPanicParameter from '@/models/game/parameters/wani-panic'
import WhackMoleParameter from '@/models/game/parameters/whack-mole'
import { GameType, Property } from '@/models/game/property'
import PlayInfo from '@/models/game/response/play-info'
import PresentCatchParameter from './parameters/present-catch'

export default class GameCampaignContents {

  private _gameProperty: Property
  private _gameParameter: GameParameterInterface
  private _playInfo: PlayInfo

  constructor(
    gameContents: any
  ) {

    this._gameProperty = new Property(gameContents.game_properties)

    // 新規ゲームを追加する際などは https://my-color.esa.io/posts/981 を参照
    switch (this._gameProperty.type) {

      case GameType.Janken:
        this._gameParameter = new JankenParameter(gameContents.game_parameters)
        break

      case GameType.Scratch:
        this._gameParameter = new ScratchParameter(gameContents.game_parameters)
        break

      case GameType.Roulette:
        this._gameParameter = new RouletteParameter(gameContents.game_parameters)
        break

      case GameType.SelectCard:
        this._gameParameter = new SelectCardParameter(gameContents.game_parameters)
        break

      case GameType.Gameless:
        this._gameParameter = new GamelessParameter(gameContents.game_parameters)
        break

      case GameType.Barrel:
        this._gameParameter = new BarrelParameter(gameContents.game_parameters)
        break

      case GameType.WhackMole:
        this._gameParameter = new WhackMoleParameter()
        break

      case GameType.Balloon:
        this._gameParameter = new BalloonParameter(gameContents.game_parameters)
        break

      case GameType.Gacha:
        this._gameParameter = new GachaParameter(gameContents.game_parameters)
        break

      case GameType.WaniPanic:
        this._gameParameter = new WaniPanicParameter(gameContents.game_parameters)
        break

      case GameType.Slot:
        this._gameParameter = new SlotParameter(gameContents.game_parameters)
        break

      case GameType.MovieGacha:
        this._gameParameter = new MovieGachaParameter(gameContents.game_parameters)
        break

      case GameType.TurningLottery:
        this._gameParameter = new TurningLotteryParameter(gameContents.game_parameters)
        break

      case GameType.Crane:
        this._gameParameter = new CraneParameter(gameContents.game_parameters)
        break

      case GameType.Memory:
        this._gameParameter = new EmptyParameter()
        break

      case GameType.PresentCatch:
        this._gameParameter = new PresentCatchParameter()
        break

      default:
        break
    }

    this._playInfo = new PlayInfo({
      play_info: gameContents.play_info,
    })
  }

  get gameProperty(): Property {
    return this._gameProperty
  }

  get gameParameter(): GameParameterInterface {
    return this._gameParameter
  }

  get playInfo(): PlayInfo {
    return this._playInfo
  }
}
